<!--begin::Root-->
<div class="d-flex flex-column flex-lg-row flex-column-fluid">
  <!--begin::Body-->
  <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-0 order-1 order-lg-1">
    <!--begin::Form-->
    <div class="d-flex flex-center flex-column flex-lg-row-fluid">
      <!--begin::Wrapper-->
      <div class="w-lg-550px p-6">
        <!--begin::Header-->
        <div class="d-flex flex-stack mb-10">
          <a href="https://cpa.education/" target="_blank">
            <img alt="Logo" src="./assets/media/logos/pro_ai.png" class="h-30px" />
          </a>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="btn btn-sm btn-light-danger" (click)="logout()">
              Sign out
            </button>
            <button type="button" class="btn btn-sm btn-icon btn-light-primary" (click)="loadOrganizations()"
              ngbTooltip="Refresh">
              <i class="ki-outline ki-arrows-circle fs-4"></i>
            </button>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Heading-->
        <div class="text-center mb-10">
          <h2 class="text-primary fw-bold fs-3 mb-3">Please select the company you want to work</h2>
          <div class="text-gray-600 fw-semibold fs-6">{{currentUser?.email}}</div>
        </div>
        <!--end::Heading-->

        <!--begin::Skeleton Loading-->
        <ng-container *ngIf="isLoading">
          <div class="d-flex flex-column gap-4">
            <div class="placeholder-glow" *ngFor="let i of [1, 2, 3]">
              <div class="border border-gray-300 border-dashed rounded p-5">
                <span class="placeholder col-8 bg-gray-300 rounded"></span>
              </div>
            </div>
          </div>
        </ng-container>
        <!--end::Skeleton Loading-->

        <!--begin::Empty State-->
        <ng-container *ngIf="!isLoading && orgs?.length === 0">
          <div class="d-flex flex-column align-items-center justify-content-center py-15">
            <i class="ki-outline ki-briefcase fs-3x text-gray-400 mb-5"></i>
            <h4 class="text-gray-900 fw-bold mb-2">No Companies Found</h4>
            <p class="text-gray-600 fw-semibold fs-6 mb-0 text-center">You don't have any companies assigned yet.</p>
          </div>
        </ng-container>
        <!--end::Empty State-->

        <!--begin::Company List-->
        <ng-container *ngIf="!isLoading && orgs?.length > 0">
          <div class="mh-400px scroll-y">
            <div class="d-flex flex-column gap-3">
              <div class="card card-flush border border-gray-300 cursor-pointer hover:bg-gray-50 transition"
                *ngFor="let item of orgs; let i = index; trackBy: trackByOrgId"
                (click)="switchOrganization(item.org_Id)" style="cursor: pointer;">
                <div class="card-body py-4 px-5 d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="symbol symbol-45px me-4">
                      <span class="symbol-label fs-4 fw-bold"
                        [ngClass]="['bg-light-primary text-primary', 'bg-light-success text-success', 'bg-light-info text-info', 'bg-light-warning text-warning', 'bg-light-danger text-danger'][i % 5]">
                        {{item?.companyName?.charAt(0)?.toUpperCase()}}
                      </span>
                    </div>
                    <span class="text-gray-900 fw-semibold fs-6 text-break">
                      {{item?.companyName}}
                    </span>
                  </div>
                  <i class="ki-outline ki-arrow-right fs-5 text-gray-600 ms-3 flex-shrink-0"></i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!--end::Company List-->

        <!--begin::Accordion-->
        <div class="mt-10">
          <div ngbAccordion>
            <div ngbAccordionItem [collapsed]="true">
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="fs-6 text-gray-700 fw-semibold">
                  <i class="ki-outline ki-question-2 fs-5 me-2"></i>
                  Why do I have multiple companies?
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <span class="text-gray-600 fw-semibold fs-6">You work for multiple companies or have been invited to
                      collaborate with different organizations.</span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Accordion-->
      </div>
      <!--end::Wrapper-->

      <!--begin::Footer-->
      <div class="d-flex flex-center flex-wrap px-5">
        <div class="d-flex fw-semibold text-primary fs-base">
          <a href="https://cpa.education/" class="px-5 fw-bold" target="_blank">
            <img alt="Logo" src="./assets/media/logos/CPATOTALBLACK.png" class="h-55px" />
          </a>
        </div>
      </div>
      <!--end::Footer-->
    </div>
    <!--end::Form-->
  </div>
  <!--end::Body-->

  <!--begin::Aside-->
  <div class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-2 order-lg-2"
    style="min-height: 100vh; background-image: url(./assets/media/misc/auth-bg.png); background-attachment: fixed; background-size: cover; background-position: center;">
    <!--begin::Content-->
    <div class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
      <!--begin::Logo-->
      <a href="https://cpa.education/" target="_blank" class="mb-12">
        <img alt="Logo" src="./assets/media/logos/CPATOTALBLACK1.png" class="h-75px w-300px" />
      </a>
      <!--end::Logo-->

      <!--begin::Title-->
      <h1 class="text-white fs-2qx fw-bolder mb-7 text-center">
        QBO - CPA - EA: Empower Your Accounting Future
      </h1>
      <!--end::Title-->

      <!--begin::Features List-->
      <div class="w-100 px-5 px-lg-10">
        <!--begin::Row 1-->
        <div class="row g-5 mb-5">
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-success me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Collaborative Rooms</span>
                <span class="text-gray-400 fw-semibold fs-7">Perfect for group study and projects.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-success me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Mentorship Programs</span>
                <span class="text-gray-400 fw-semibold fs-7">Connect Mentees and faculty.</span>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row 1-->

        <!--begin::Row 2-->
        <div class="row g-5 mb-5">
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-primary me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Interactive AI Tutors</span>
                <span class="text-gray-400 fw-semibold fs-7">Experience personalized learning.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-primary me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Engaging Chat Tools</span>
                <span class="text-gray-400 fw-semibold fs-7">Facilitate direct communication.</span>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row 2-->

        <!--begin::Row 3-->
        <div class="row g-5 mb-5">
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-danger me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">User-generated Q&A</span>
                <span class="text-gray-400 fw-semibold fs-7">Access rich educational materials.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-danger me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Smart Notes</span>
                <span class="text-gray-400 fw-semibold fs-7">Enhance and streamline your learning.</span>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row 3-->

        <!--begin::Row 4-->
        <div class="row g-5 mb-5">
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-warning me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Certification Opportunities</span>
                <span class="text-gray-400 fw-semibold fs-7">Create, teach, and earn credentials.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-warning me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Networking</span>
                <span class="text-gray-400 fw-semibold fs-7">Build connections with mentors and peers.</span>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row 4-->

        <!--begin::Row 5-->
        <div class="row g-5 mb-8">
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-info me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Seamless Collaboration</span>
                <span class="text-gray-400 fw-semibold fs-7">Achieve together effortlessly.</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex align-items-start">
              <span class="bullet bullet-vertical h-40px bg-info me-4 flex-shrink-0"></span>
              <div class="d-flex flex-column">
                <span class="text-white fw-semibold fs-6">Future-focused</span>
                <span class="text-gray-400 fw-semibold fs-7">Propel your learning journey forward.</span>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row 5-->
      </div>
      <!--end::Features List-->

      <!--begin::YouTube Link-->
      <a href="https://www.youtube.com/@accountant-world-ai" target="_blank"
        class="btn btn-flex btn-outline btn-outline-white btn-active-color-white px-6 py-3">
        <i class="ki-outline ki-youtube fs-2 me-2"></i>
        <span class="fw-bold">Watch Our Videos</span>
      </a>
      <!--end::YouTube Link-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Aside-->
</div>
<!--end::Root-->